import styled from "styled-components";

export const MainContainer = styled.footer`
  position: relative;
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.border.primary};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0;
`;
